import React from 'react';
import { Link } from 'react-router-dom';

export default function UserProfileCard({
  userId,
  username,
  email,
  profileImageUrl,
  rosterCount = 0,
  factionCount = 0,
  favoriteFactionName = '',
  onEdit
}) {
  const hasMultipleFactions = factionCount > 1;
  const profileStatus = profileImageUrl ? 'Personalizzato' : 'Da completare';

  return (
    <div className="card shadow-sm profile-user-card border-0">
      <div className="card-body profile-user-card__hero">
        <div className="profile-user-card__hero-top">

          <div className="profile-user-card__identity">
            <div className="profile-user-card__avatar-wrap">
              {profileImageUrl ? (
                <img
                  src={profileImageUrl}
                  alt={username}
                  className="profile-user-card__avatar"
                />
              ) : (
                <div className="profile-user-card__avatar profile-user-card__avatar--fallback">
                  {username?.charAt(0).toUpperCase() || 'U'}
                </div>
              )}
            </div>
            <div className="profile-user-card__copy">
              <h3 className="brand-title mb-2 text-white">
                {username || 'Utente'}
              </h3>
              <p className="text-muted-brand mb-0 profile-user-card__email">
                <i className="bi bi-envelope me-2"></i>
                {email || 'Email non disponibile'}
              </p>
            </div>

          </div>
          <button
            className="btn btn-outline-brand-secondary btn-sm rounded-pill profile-user-card__edit-btn"
            onClick={onEdit}
            title="Modifica profilo"
          >
            <i className="bi bi-pencil-fill me-2"></i>
            Modifica
          </button>
        </div>

          <div className="profile-user-card__mini">
            <small>Fazione preferita</small>
            <strong>{favoriteFactionName || 'Non impostata'}</strong>
          </div>
        {hasMultipleFactions && userId && (
          <div className="profile-user-card__actions">
            <Link
              to={`/users/${userId}`}
              className="btn btn-brand-secondary rounded-pill profile-user-card__overview-btn profile-user-card__overview-btn--mobile"
            >
              <i className="bi bi-diagram-3-fill me-2"></i>
              Vedi panoramica fazioni
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
